export class TemperatureValue {
  static readonly MAX_DIGITS = 2;
  static readonly MAX_DECIMALS = 2;

  static capInput(raw: string): string {
    const trimmed = raw.trim();
    if (!trimmed) return "";
    const negative = trimmed.startsWith("-");
    const body = (negative ? trimmed.slice(1) : trimmed).replace(/[^\d.]/g, "");
    const dot = body.indexOf(".");
    const whole = (dot === -1 ? body : body.slice(0, dot))
      .replace(/\D/g, "")
      .slice(0, TemperatureValue.MAX_DIGITS);
    if (dot === -1) {
      if (!whole) return negative ? "-" : "";
      return negative ? `-${whole}` : whole;
    }
    const frac = body.slice(dot + 1).replace(/\D/g, "").slice(0, TemperatureValue.MAX_DECIMALS);
    const assembled = `${whole}.${frac}`;
    return negative ? `-${assembled}` : assembled;
  }
}
